import { TranslationDict } from "../types";

export const frNavbar: TranslationDict = {
  bestand: "Fichier",
  nieuw: "Nouveau",
  open: "Ouvrir",
  bewaar: "Enregistrer",
  maakOfferte: "Créer une offre",
  maakOverzicht: "Créer un aperçu",
  afwerking: "Finition",
  instellingen: "Paramètres",
  installateur: "Installateur",
  afmelden: "Se déconnecter",
  klant: "Client",
  maakKlant: "Créer un nouveau client",
  opties: "Options",
  project: "Projet",
};
